import React from "react";
import "../styles/FocusCallout.css";
import focusImage from "../assets/focus-image.png"; // Replace with the actual image path
//import googleAds from "../assets/achievement-icon.png";
//import metaLogo from "../assets/achievement-icon.png";
//import linkedinLogo from "../assets/achievement-icon.png";
//import tiktokLogo from "../assets/achievement-icon.png";
//import placeholderImage from "../assets/achievement-icon.png";
import { Link } from "react-router-dom";

const FocusCallout = () => {
  // Array of achievement icons with their image paths
  /*const achievements = [
    { id: 1, src: googleAds, alt: "Google Ads" },
    { id: 2, src: metaLogo, alt: "Meta" },
    { id: 3, src: linkedinLogo, alt: "LinkedIn" },
    { id: 4, src: tiktokLogo, alt: "TikTok" },
    { id: 5, src: placeholderImage, alt: "Placeholder Achievement" },
    { id: 6, src: placeholderImage, alt: "Placeholder Achievement" },
  ];*/

  return (
    <section className="focus-callout-section">
      {/* Top Section */}
      <div className="focus-top-container">
        <div className="focus-text">
          <h2 className="focus-title">
            Our Focus To <span className="highlight">YOU</span>
          </h2>
          
          <p className="focus-description">
            <strong>When using Growth Labs, our commitment is to maximize your growth
            and giving you the ability to scale your marketing efforts towards the future. 
            Get your FREE marketing audit and we’ll show you how.</strong>
          </p>
        </div>

        {/* Right Image */}
        <div className="focus-image">
          <img src={focusImage} alt="Focus Callout" />
        </div>
      </div>

    <div className="focus-description-mobile">
      <p>
        <strong>
          When using Growth Labs, our commitment is to maximize your growth and
          giving you the ability to scale your marketing efforts towards the
          future. Get your FREE marketing audit and we’ll show you how.
        </strong>
      </p>
      </div>

      {/* Bottom Section */}
      <div className="focus-bottom-container">
        <p className="focus-details">
          When it comes to performance marketing, we keep our eyes on the data
          and throw vanity metrics to the side. You’ll rarely hear us speak
          about anything other than the KPI’s you’ve set for us. We keep our
          distractions to a minimum and deploy tried and true tactics that allow
          us to maximize your ROI.
        </p>
      </div>

      {/* CTA Below Cards */}
      <div className="focus-callout-cta">
        <p className="focus-callout-cta-text">
          Click below to Schedule Your FREE Growth Audit!
        </p>
        <Link to="/lead-form" className="focus-callout-cta-button">
          Get Started
        </Link>
      </div>

      {/* Achievements Section 
      <div className="focus-achievements">
        <h4>Our Achievements</h4>
        <div className="achievement-icons">
          {achievements.map((item) => (
            <img
              key={item.id}
              src={item.src}
              alt={item.alt}
              className="achievement-icon"
            />
          ))}
        </div>
      </div>*/}
    </section>
  );
};

export default FocusCallout;
